import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import {
  SchedulesRBAC,
  BulkUploadSchedulesRBAC,
  MasterApprovalRBAC,
  MasterShiftRBAC,
  AttendanceRBAC,
  OJTSlottingRBAC,
} from './rbac'

const HubStaffSchedule = lazy(() => import('../pages/HubStaffSchedule'))
const MasterApproval = lazy(() => import('../pages/MasterApproval'))
const MasterShift = lazy(() => import('../pages/MasterShift'))
const ManPowerBulkUpload = lazy(() => import('../../HRIS/pages/ManPowerBulkUpload'))
const OJTSlotting = lazy(() => import('../pages/OJTSlotting'))

export const ScheduleRouter: RouterFeatureInterface<
  'ScheduleRouter',
  '/dashboard/hub-staff/schedule'
> = {
  name: 'ScheduleRouter',
  Component: () => <HubStaffSchedule type="schedule" />,
  path: '/dashboard/hub-staff/schedule',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SchedulesRBAC.pageID,
}

export const ScheduleBulkUploadRouter: RouterFeatureInterface<
  'ScheduleBulkUploadRouter',
  '/dashboard/hub-staff/schedule/bulk-upload'
> = {
  name: 'ScheduleBulkUploadRouter',
  Component: () => <ManPowerBulkUpload type="workingSchedule" />,
  path: '/dashboard/hub-staff/schedule/bulk-upload',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: BulkUploadSchedulesRBAC.pageID,
}

export const AttendanceRouter: RouterFeatureInterface<
  'AttendanceRouter',
  '/dashboard/hub-staff/attendance'
> = {
  name: 'AttendanceRouter',
  Component: () => <HubStaffSchedule type="attendance" />,
  path: '/dashboard/hub-staff/attendance',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: AttendanceRBAC.pageID,
}

export const MasterApprovalRouter: RouterFeatureInterface<
  'MasterApproval',
  '/dashboard/hub-staff/master-approval'
> = {
  name: 'MasterApproval',
  Component: MasterApproval,
  path: '/dashboard/hub-staff/master-approval',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterApprovalRBAC.pageID,
}

export const MasterShiftRouter: RouterFeatureInterface<'MasterShift', '/dashboard/master-shift'> = {
  name: 'MasterShift',
  Component: MasterShift,
  path: '/dashboard/master-shift',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterShiftRBAC.pageID,
}

export const OJTSlottingRouter: RouterFeatureInterface<
  'OJTSlottingRouter',
  '/dashboard/ojt-slotting'
> = {
  name: 'OJTSlottingRouter',
  Component: OJTSlotting,
  path: '/dashboard/ojt-slotting',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: OJTSlottingRBAC.pageID,
}

const SchedulesRouter = [
  ScheduleRouter,
  AttendanceRouter,
  MasterApprovalRouter,
  MasterShiftRouter,
  ScheduleBulkUploadRouter,
  OJTSlottingRouter,
]

export const SchedulesRouterDetail = generateRouterDetail(SchedulesRouter)

export default SchedulesRouter
